import "core-js/modules/esnext.global-this.js";
import { __rest, __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import '../../node_modules/lodash/_Stack.js';
import '../../node_modules/lodash/_SetCache.js';
import '../../node_modules/lodash/_equalByTag.js';
import '../../node_modules/lodash/isArguments.js';
import '../../node_modules/lodash/isBuffer.js';
import '../../node_modules/lodash/isTypedArray.js';
import '../../node_modules/lodash/_baseGetTag.js';
import '../../node_modules/lodash/_getTag.js';
import '../provider/WindowSizeContext.js';
import '../provider/ColorModeContext.js';
import { useHasMounted } from '../../hooks/useHasMounted.js';
import { useCookieConsentStyle } from './useCookieConsentStyle.js';
var CookieConsent = React__default.memo(function (_a) {
  var apiKey = _a.apiKey,
    lang = _a.lang,
    siteId = _a.siteId,
    cookiePolicyId = _a.cookiePolicyId,
    _b = _a.consentOnContinuedBrowsing,
    consentOnContinuedBrowsing = _b === void 0 ? false : _b,
    _c = _a.invalidateConsentWithoutLog,
    invalidateConsentWithoutLog = _c === void 0 ? true : _c,
    _d = _a.perPurposeConsent,
    perPurposeConsent = _d === void 0 ? true : _d,
    _e = _a.gdprAppliesGlobally,
    gdprAppliesGlobally = _e === void 0 ? true : _e,
    _f = _a.askConsentAtCookiePolicyUpdate,
    askConsentAtCookiePolicyUpdate = _f === void 0 ? true : _f,
    rest = __rest(_a, ["apiKey", "lang", "siteId", "cookiePolicyId", "consentOnContinuedBrowsing", "invalidateConsentWithoutLog", "perPurposeConsent", "gdprAppliesGlobally", "askConsentAtCookiePolicyUpdate"]);
  var hasMounted = useHasMounted();
  var bannerStyle = useCookieConsentStyle();
  React__default.useEffect(function () {
    var iub = globalThis._iub || {};
    globalThis._iub = __assign(__assign({}, iub), {
      csConfiguration: __assign(__assign({
        siteId: siteId,
        lang: lang,
        cookiePolicyId: cookiePolicyId,
        consentOnContinuedBrowsing: consentOnContinuedBrowsing,
        invalidateConsentWithoutLog: invalidateConsentWithoutLog,
        perPurposeConsent: perPurposeConsent,
        gdprAppliesGlobally: gdprAppliesGlobally,
        askConsentAtCookiePolicyUpdate: askConsentAtCookiePolicyUpdate
      }, rest), {
        banner: bannerStyle
      })
    });
  }, [askConsentAtCookiePolicyUpdate, bannerStyle, consentOnContinuedBrowsing, cookiePolicyId, gdprAppliesGlobally, invalidateConsentWithoutLog, lang, perPurposeConsent, rest, siteId]);
  React__default.useEffect(function () {
    var iub = globalThis._iub || {};
    iub.cons_instructions = __spreadArray(__spreadArray([], iub.cons_instructions || [], true), [["init", {
      api_key: apiKey
    }]], false);
  }, [apiKey]);
  React__default.useEffect(function () {
    if (hasMounted) {
      var script_1 = document.createElement("script");
      script_1.type = "text/javascript";
      script_1.async = true;
      script_1.src = "//cdn.iubenda.com/cs/iubenda_cs.js";
      script_1.onload = function () {
        globalThis._iub.cc = "EU";
      };
      if (document.body != null) {
        document.body.appendChild(script_1);
      }
      return function () {
        if (document.body != null) {
          document.body.removeChild(script_1);
        }
      };
    }
  }, [apiKey, cookiePolicyId, lang, siteId, hasMounted]);
  return null;
});
export { CookieConsent };